(() => {
  if (window.__alcimoLaunchModalLoaded) return;
  window.__alcimoLaunchModalLoaded = true;

  const getModal = () => document.querySelector('[data-alcimo-launch-modal]');

  const ensureModalInBody = () => {
    const modal = getModal();
    if (!modal) return null;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    return modal;
  };

  const setCheckoutState = (modal) => {
    const checkbox = modal?.querySelector('[data-alcimo-launch-accept]');
    const checkout = modal?.querySelector('[data-alcimo-launch-checkout]');
    if (!checkbox || !checkout) return;

    checkout.disabled = !checkbox.checked;
    checkout.setAttribute('aria-disabled', String(!checkbox.checked));
  };

  const openModal = () => {
    const modal = ensureModalInBody();
    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('alcimo-launch-modal-open');
    document.body.classList.add('alcimo-launch-modal-open');
    setCheckoutState(modal);

    window.setTimeout(() => {
      modal.querySelector('.alcimo-launch-modal__dialog')?.focus();
    }, 20);
  };

  const closeModal = () => {
    const modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('alcimo-launch-modal-open');
    document.body.classList.remove('alcimo-launch-modal-open');
    document.querySelector('[data-alcimo-launch-open]')?.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-alcimo-launch-open]');
    if (opener) {
      event.preventDefault();
      if (!opener.disabled) openModal();
      return;
    }

    if (event.target.closest('[data-alcimo-launch-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-alcimo-launch-accept]')) {
      setCheckoutState(getModal());
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && getModal()?.classList.contains('is-open')) {
      closeModal();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const modal = ensureModalInBody();
    setCheckoutState(modal);
  });
})();
